import {connect} from 'react-redux';
import React, {useEffect, useMemo, useState} from 'react';
import {compose} from 'redux';
import _ from 'lodash';

import AppButton from '../../../components/app-button';
import Header1 from '../../../components/headers/header1';
import {Column, Row} from '../../../components/layout';
import {
  addToGlobalStyles,
  setGlobalStyles,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  setWizard,
  setIban,
  setTitular,
  setUserBankAccountDataWasUpdated,
} from '../../../store/actions';
import colors, {pageBackgrounds} from '../../../util/colors';
import * as fonts from '../../../util/fonts';

import './styles.scss';
import Icon from '../../../components/icon';
import {Icons} from '../../../util/icons';
import AppWrapper from '../../../components/app-wrapper';
import ReimbursementsList from './components/ReimbursementsList';
import {get} from '../../../api/api';
import {
  getPartialRefusalReasons,
  uriIreneCoverages,
  uriMemberData,
  uriRefundDetails,
  uriRefunds,
  uriStatuses,
  uriRefundPaymentDetails,
} from '../../../api/endpoints';
import {functionalitiesAliasMap, strings} from '../../../util/strings';
import {useHistory} from 'react-router-dom';
import moment from 'moment';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';
import ReimbursementsDetail from './components/ReimbursementsDetail';
import ClaimItemsFilter, {
  ClaimItemsFilterProps,
} from '../components/ClaimItemsFilter';
import {
  createCoveragesMap,
  createGUID,
  sortArrayByParam,
} from '../../../util/utility';
import ClaimsFilterModal from '../components/ClaimsFilterModal';
import {ReimbursementItem} from './interfaces';
import AppSpinner from '../../../components/app-spinner';
interface ReimbursementHistoryProps {
  user: any;
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  setIbanFilterOpenTrigger(value: any): void;
  setDisableReimbursementRequestButton(value: any): void;
  selectedBu: any;
  labels: typeof strings.pt.refund;
  stringsIban: typeof strings.pt.ibanRefunds;
  createRefundLabels: typeof strings.pt.createRefund;
  setWizard(values: any): void;
  availableBus: any[];
  buStyles: any;
  iban: any;
  busFuncMap: any;
  titular: any;
  bankAccountDataHolder: any;
  userBankAccountDataWasUpdated: boolean;
  setUserBankAccountDataWasUpdated: Function;
  setIban: Function;
  setTitular: Function;
}

export interface ReimbursementApiResponse {
  data: ReimbursementItem[];
  total: number;
  StatusCode: number;
}

function ReimbursementHistory({
  user,
  addToGlobalStyles,
  setGlobalStyles,
  setIbanFilterOpenTrigger,
  setDisableReimbursementRequestButton,
  selectedBu,
  labels,
  setWizard,
  availableBus,
  buStyles,
  iban,
  busFuncMap,
  titular,
  bankAccountDataHolder,
  stringsIban,
  createRefundLabels,
  userBankAccountDataWasUpdated,
  setUserBankAccountDataWasUpdated,
  setIban,
  setTitular,
}: ReimbursementHistoryProps) {
  const [selectedItem, setSelectedItem] = useState<{
    auditNbr?: string;
    catCode?: string;
    catName?: string;
    estadoId?: string;
    estado?: string;
    lastupdate?: string;
    providerName?: string;
    clinicName?: string;
    rede?: string;
    isCat9?: number;
    dosFrom?: string;
    dosThru?: string;
    submittedBy?: string;
    amountpaid?: number;
    sessionId?: string;
    processNbr?: string;
    checkDate?: string;
  }>({});
  const [showModal, setShowModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterShouldRefresh, setFilterShouldRefresh] = useState(false);
  const [completedSessionIdList, setCompletedSessionIdList] = useState<any[]>(
    []
  );
  const [refunds, setrefunds] = useState<ReimbursementApiResponse>();
  const [refundDetails, setrefundDetails] = useState<any[]>([]);
  const [statuses, setstatuses] = useState<any[]>([]);
  const [coverages, setcoverages] = useState<any[]>([]);
  const [updateFlag, setUpdateFlag] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [canCreateReimbursment, setCanCreateReimbursement] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingPaymentDetail, setLoadingPaymentDetail] = useState(false);
  const [errorLoadingDetail, setErrorLoadingDetail] = useState(false);
  const [canCreateWithMessage, setCanCreateWithMessage] = useState(false);
  const history = useHistory();
  const [currency, setCurrency] = useState<string>();
  const [disableCreateRefundButton, setDisableCreateRefundButton] =
    useState(false);
  const [msgBelowCreateRefundButton, setMsgBelowCreateRefundButton] =
    useState<any>(<></>);
  const [ibanDetails, setIbanDetails] = useState('');
  let statusId = selectedItem.estadoId?.toLowerCase();
  let color = statuses.find((e) => e.value == statusId)?.colorCode;

  const featureName = 'ReimbursementList';

  const createRefundActive = busFuncMap[selectedBu.buId]?.find(
    (func: any) =>
      func.featureTemplateAlias === functionalitiesAliasMap.createRefund
  );

  const ibanFuncActive = busFuncMap[selectedBu.buId]?.find(
    (func: any) => func?.featureTemplateAlias === functionalitiesAliasMap.iban
  )?.isVisible;

  const isTitularLogged =
    bankAccountDataHolder === 'SUBSCRIBER'
      ? titular?.memId === selectedBu?.memId &&
        titular?.buId === selectedBu?.buId
      : true;

  const changedItem = (filterItem: ReimbursementItem) => {
    if (filterItem.estadoId === '101') {
      get(
        uriRefundDetails(
          selectedBu.buId,
          filterItem.auditNbr,
          filterItem.processNbr,
          filterItem.sessionId,
          filterItem.isCat9,
          filterItem.catCode
        )
      ).then((res: any) => {
        const metadata = res.data.refundsOcr.metadata;
        const patients = Object.keys(availableBus).map((key: any) => {
          const bu = availableBus[key];
          return {...bu, id: createGUID()};
        });
        const selectedPatient =
          patients.find(
            (patient) => !!patient.nif && patient.nif === metadata.nif
          ) || patients[0];
        let patientValidation = {
          patients,
          ...selectedPatient,
        };

        const files = metadata.documents.map((document: any) => {
          const aux = (document.fileName as string)?.split('/');
          return {
            path: (aux && aux[aux.length - 1]) || document.fileName,
            preview: document.fileName,
            id: createGUID(),
            name: 'Fatura',
          };
        });
        setWizard({
          step: 2,
          patientValidation,
          attachFiles: {
            sessionId: filterItem.sessionId,
            files,
          },
          invoiceValidation: metadata,
        });
        history.push('/historico-reembolsos/pedido-reembolso', {
          downloadBlobs: true,
        });
      });
    } else {
      setShowModal(true);
      var newFilterItem = {...selectedItem};
      (newFilterItem as any) = filterItem;
      setSelectedItem(newFilterItem);
    }
  };

  const filterParameterChanged = (
    filterParameter: string,
    ParameterValue: string | Date
  ) => {
    var newFilter = {...filter};
    (newFilter as any)[filterParameter] = ParameterValue;
    setFilter(newFilter);
    setFilterShouldRefresh(true);
  };

  const modalWasClosed = () => {
    setFilterShouldRefresh(filter.filtersHaveChanged);
  };

  let filterProps: ClaimItemsFilterProps = {
    controlLabels: {
      filterParmOne: labels?.filterCoverageLabel,
      filterParmTwo: labels?.filterStatusLabel,
      filterDateFrom: labels?.filterDateLabel,
    },
    filterOneOptions: [],
    filterTwoOptions: [],
    filterParmOne: '',
    filterParmTwo: '',
    periodFrom: moment().subtract(6, 'month').toDate(),
    periodTill: moment().toDate(),
    filterParameterChanged: filterParameterChanged,
    filtersHaveChanged: filterShouldRefresh,
  };

  const [filter, setFilter] = useState<ClaimItemsFilterProps>(filterProps);

  const getListOfRefunds = async () => {
    const filterFromDate =
      filter.periodFrom === undefined
        ? '1900-01-01'
        : moment(filter.periodFrom).format('YYYY-MM-DD');
    const filterToDate =
      filter.periodTill === undefined
        ? '2030-12-31'
        : moment(filter.periodTill).format('YYYY-MM-DD');
    try {
      return await get(
        uriRefunds(
          selectedBu.buId,
          selectedBu.memId,
          0,
          filterFromDate,
          filterToDate,
          10000,
          filter.filterParmOne,
          filter.filterParmTwo
        )
      );
    } catch (e: any) {
      return [];
    }
  };
  const getTheRefunds = () => {
    setIsLoading(true);
    if (selectedBu) {
      getListOfRefunds()
        .then((res: any) => {
          setrefunds(res as ReimbursementApiResponse);
          setCurrency(res?.data?.[0]?.currency);
        })
        .catch((err) => {
          console.log(err);
          setrefunds({} as ReimbursementApiResponse);
          setCurrency(createRefundLabels.default_currency);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    const getMemberData = async () => {
      const memberData: any = await get(
        uriMemberData(selectedBu?.buId, selectedBu?.memId, selectedBu?.famId)
      );
      if (bankAccountDataHolder == 'INDIVIDUAL') {
        setIban(memberData?.iban);
        setTitular(memberData);
      }
      setUserBankAccountDataWasUpdated(false);
    };

    selectedBu?.memId && userBankAccountDataWasUpdated && getMemberData();
  }, [userBankAccountDataWasUpdated]);

  useEffect(() => {
    setFilterShouldRefresh(true);
    processCanCreateReimbursement();
  }, [selectedBu.memId, updateFlag]);

  useEffect(() => {
    if (filterShouldRefresh) {
      getTheRefunds();
      setFilterShouldRefresh(false);
    }
  }, [filterShouldRefresh]);

  useEffect(() => {
    processCanCreateReimbursement();
  }, [stringsIban?.ibanRefunds_ibanIsEnabled]);

  const ItemFinishedSubmitting = (sessionId: any) => {
    const alreadyFinished = !!completedSessionIdList.find(
      (elem) => elem === sessionId
    );
    if (!alreadyFinished) {
      getTheRefunds();
      const newCompletedSessionIdList: any[] = [...completedSessionIdList];
      newCompletedSessionIdList.push(sessionId);
      setCompletedSessionIdList(newCompletedSessionIdList);
    }
  };

  useEffect(() => {
    addToGlobalStyles({
      background: pageBackgrounds.reimbursementPage,
    });
  }, []);

  useEffect(() => {
    async function getListOfStatuses() {
      return await get(uriStatuses(), false, 0, featureName);
    }

    async function getListOfCoverages() {
      if (selectedBu) {
        return await get(
          uriIreneCoverages(selectedBu.buId, selectedBu.benNbr),
          false,
          0,
          featureName
        );
      }
    }

    let newFilter = {...filter};

    getListOfStatuses().then((res: any) => {
      const statusOptions = (res.data?.items as any[])
        .filter((elem) => elem.stateName !== 'Default')
        .map((elem) => {
          return {
            value: elem.stateId,
            label: elem.stateName,
            colorCode: elem.color,
            stateId: elem.stateId,
          };
        });

      const sortedOptions = sortArrayByParam(statusOptions, 'label');
      setstatuses(sortedOptions);
      newFilter.filterTwoOptions = sortedOptions;
      setFilter(newFilter);
    });

    getListOfCoverages().then((res: any) => {
      const coveragesMap = createCoveragesMap(res?.data?.items);
      const coverageOptions = Object.values(coveragesMap).map((elem: any) => {
        return {value: elem.catCode, label: elem.catCodeDesc};
      });
      const sortedOptions = sortArrayByParam(coverageOptions, 'label');
      setcoverages(sortedOptions);
      newFilter.filterOneOptions = sortedOptions;
      setFilter(newFilter);
    });

    setFilterShouldRefresh(true);
  }, []);

  useEffect(() => {
    setErrorLoadingDetail(false);
    async function getRefundDetails() {
      setLoadingDetail(true);
      let result: any = await get(
        uriRefundDetails(
          selectedBu.buId,
          selectedItem.auditNbr,
          selectedItem.processNbr,
          selectedItem.sessionId,
          selectedItem.isCat9,
          selectedItem.catCode
        )
      );
      return result.data;
    }
    if (showModal) {
      setIsLoading(true);
      getRefundDetails()
        .then((res: any) => {
          let aux: Expense[] = res.refunds;
          res.refunds.forEach((ref: any) => {
            if (ref.amountDisallow > 0) {
              get(getPartialRefusalReasons(selectedBu.buId, ref?.code)).then(
                (partialRefusalReason: any) => {
                  if (partialRefusalReason?.data?.items?.length > 0) {
                    const index = res.refunds.indexOf(ref);
                    aux[index]['partialRefusalReason'] =
                      partialRefusalReason?.data?.items;
                  }
                }
              );
            }
            setrefundDetails(aux);
          });
          if (
            aux[0]?.checkNbr &&
            selectedItem.estadoId === '6' &&
            selectedItem.amountpaid! >= 0.01
          ) {
            getRefundPaymentDetails(aux[0]?.checkNbr);
          }
        })
        .catch(() => {
          setErrorLoadingDetail(true);
        })
        .finally(() => {
          setIsLoading(false);
          setLoadingDetail(false);
        });
    } else if (!showModal) {
      setrefundDetails([]);
    }
  }, [showModal]);

  const getRefundPaymentDetails = async (checkNbr: any) => {
    try {
      setLoadingPaymentDetail(true);
      let resultToFormat: any = await get(
        uriRefundPaymentDetails(selectedBu.buId, checkNbr)
      );
      if (resultToFormat?.data?.nib) {
        setIbanDetails(resultToFormat?.data?.nib);
      } else {
        setIbanDetails('');
      }
    } catch {
      setIbanDetails('');
    } finally {
      setLoadingPaymentDetail(false);
    }
  };

  const handleDefineIban = () => {
    setIbanFilterOpenTrigger({ibanFilter: true});
    history.push('/meus-dados');
  };

  const onClickReimbursementRequest = () => {
    setWizard({
      currency: currency,
    });
    history.push('/historico-reembolsos/pedido-reembolso');
  };

  const processCanCreateReimbursement = () => {
    if (!createRefundActive || !createRefundActive?.isVisible) {
      setCanCreateReimbursement(false);
    } else {
      if (!ibanFuncActive) {
        setCanCreateReimbursement(true);
      } else {
        if (stringsIban?.ibanRefunds_ibanIsEnabled === '1') {
          if (!titular?.iban) {
            setCanCreateReimbursement(false);
          } else {
            setCanCreateReimbursement(true);
          }
        } else {
          setCanCreateReimbursement(true);
        }
      }
    }
  };

  useMemo(() => {
    // IBAN INTERNACIONAL
    const messageBelowCreateRefundButton = () => {
      if (stringsIban?.ibanRefunds_ibanIsEnabled === '1') {
        switch (stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds) {
          case '0': {
            return isTitularLogged ? (
              <>
                {createRefundLabels?.refund_alert_owner_1}
                <a
                  className="define-iban-anchor-label"
                  style={{
                    ...fonts.SM,
                    color: buStyles?.primaryColor || colors.blue,
                    textDecoration: 'underline',
                  }}
                  onClick={() => handleDefineIban()}>
                  {createRefundLabels?.refund_alert_owner_2}
                </a>
              </>
            ) : (
              <span key={selectedBu.famId}>
                {createRefundLabels?.refund_alert_not_owner}
              </span>
            );
            break;
          }
          case '1': {
            switch (bankAccountDataHolder) {
              case 'SUBSCRIBER': {
                if (titular?.iban) {
                  setDisableCreateRefundButton(false);
                  return;
                }
                setDisableCreateRefundButton(!titular?.iban || !ibanFuncActive);
                return isTitularLogged && !titular?.iban ? (
                  <Row className="fill-iban-here">
                    {stringsIban?.ibanRefunds_fillIbanMyData}{' '}
                    <a
                      className="define-iban-anchor-label"
                      style={{
                        color: buStyles?.primaryColor || colors.blue,
                        textDecoration: 'underline',
                        marginLeft: '3px',
                      }}
                      onClick={() => {
                        setIbanFilterOpenTrigger({ibanFilter: true});
                        history.push({
                          pathname: '/meus-dados',
                          state: {patientSelected: selectedBu},
                        });
                      }}>
                      {stringsIban?.ibanRefunds_fillIbanMyDataLink}
                    </a>
                  </Row>
                ) : (
                  <span key={selectedBu.famId} className="semibold">
                    {stringsIban?.ibanRefunds_fillIbanAskTitular}
                  </span>
                );
              }
              case 'INDIVIDUAL': {
                setDisableCreateRefundButton(!titular?.iban || !ibanFuncActive);
                return (
                  !titular?.iban && (
                    <Row className="fill-iban-here">
                      {stringsIban?.ibanRefunds_fillIbanMyData}{' '}
                      <a
                        className="define-iban-anchor-label"
                        style={{
                          color: buStyles?.primaryColor || colors.blue,
                          textDecoration: 'underline',
                          marginLeft: '3px',
                        }}
                        onClick={() =>
                          history.push({
                            pathname: '/meus-dados',
                            state: {patientSelected: selectedBu},
                          })
                        }>
                        {stringsIban?.ibanRefunds_fillIbanMyDataLink}
                      </a>
                    </Row>
                  )
                );
              }
            }
            break;
          }
        }
      } else {
        if (isTitularLogged) {
          if (
            stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
          ) {
            setCanCreateWithMessage(true);
          }
          return (
            !titular?.iban && (
              <p className="semibold">
                {stringsIban?.ibanRefunds_fillIbanAskInsuranceCompany}
              </p>
            )
          );
        } else {
          if (
            stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
          ) {
            setCanCreateWithMessage(true);
            return (
              !titular?.iban && (
                <p className="semibold">
                  {stringsIban?.ibanRefunds_fillIbanAskInsuranceCompanyNotOwner}
                </p>
              )
            );
          } else {
            return (
              !titular?.iban && (
                <p className="semibold">
                  {stringsIban?.ibanRefunds_fillIbanAskTitular}
                </p>
              )
            );
          }
        }
      }
    };
    // !titular?.iban &&
    //   setDisableCreateRefundButton(
    //     !ibanFuncActive &&
    //       stringsIban?.ibanRefunds_bankAccountDataRequiredForRefunds == '1'
    //   );
    ibanFuncActive &&
      setMsgBelowCreateRefundButton(messageBelowCreateRefundButton());
  }, [selectedBu.memId, titular]);

  useEffect(() => {
    setDisableReimbursementRequestButton(disableCreateRefundButton);
  }, [disableCreateRefundButton]);

  return (
    <>
      <Column className="reimbursement-history-container ">
        <Row className="reimbursement-history-titlerow reimbursement-history-row">
          <Column className="reimbursement-history-titlecolumn">
            <Header1
              className="reimbursement-history-heading1"
              style={{...fonts.XL, ...fonts.Bold}}>
              {labels?.refundHistory_title}
            </Header1>
            <label
              className="reimbursement-history-subtitle"
              style={{...fonts.M}}>
              {labels?.refundHistory_verifyRequest}
            </label>
          </Column>
          <Column className="reimbursement-history-requestcolumn">
            {createRefundActive && createRefundActive?.isVisible && (
              <AppButton
                disabled={disableCreateRefundButton}
                onClick={() => {
                  onClickReimbursementRequest();
                }}
                className="homepage-request-reimbursement-button reimbursement-history-request-button">
                {labels?.refundHistory_addRefund}
              </AppButton>
            )}
            {((!canCreateReimbursment && createRefundActive?.isVisible) ||
              (disableCreateRefundButton && createRefundActive?.isVisible) ||
              canCreateWithMessage) && (
              <>
                <div
                  className={'create-refund-alert'}
                  style={{
                    ...fonts.SM,
                    ...fonts.SemiBold,
                  }}>
                  {/* {isTitularLogged ? (
                    <>
                      {createRefundLabels?.refund_alert_owner_1}
                      <a
                        className="define-iban-anchor-label"
                        style={{
                          ...fonts.SM,
                          color: buStyles?.primaryColor || colors.blue,
                          textDecoration: 'underline',
                        }}
                        onClick={() => handleDefineIban()}>
                        {createRefundLabels?.refund_alert_owner_2}
                      </a>
                    </>
                  ) : (
                    <span key={selectedBu.famId}>
                      {createRefundLabels?.refund_alert_not_owner}
                    </span>
                  )} */}
                  {msgBelowCreateRefundButton}
                </div>
              </>
            )}
          </Column>
        </Row>
        <Row className="reimbursement-history-row reimbursement-history-row-filter">
          <ClaimItemsFilter
            restrictDateInterval={true}
            filterParmOne={filter.filterParmOne}
            filterParmTwo={filter.filterParmTwo}
            periodFrom={filter.periodFrom}
            periodTill={filter.periodTill}
            filterParameterChanged={filterParameterChanged}
            filterTwoOptions={statuses}
            filterOneOptions={coverages}
            controlLabels={{
              ['filterParmOne']: labels?.filterCoverageLabel,
              ['filterParmTwo']: labels?.filterStatusLabel,
              ['filterDateFrom']: labels?.filterDateLabel,
            }}
            filtersHaveChanged={false}></ClaimItemsFilter>
        </Row>
        {isLoading ? (
          <AppSpinner className="loading-outlined" />
        ) : (
          <Row className="reimbursement-history-row reimbursement-history-declarationslist-row">
            <Column className="reimbursement-history-declarationslist-column">
              <Row className="reimbursement-history-declarationslist-sub-row">
                <Column className="reimbursement-history-filterbuttoncolumn">
                  <AppButton
                    className="reimbursement-history-filterbutton"
                    onClick={() => setShowFilterModal(true)}>
                    <Row className="reimbursement-history-filter-row">
                      <Icon
                        className="reimbursement-history-filter-icon"
                        name={Icons.FILTER}
                        color={colors.white}
                        width="16"
                        height="16"
                        changeViewbox={false}
                        viewBox={'0 -5 26 30'}
                      />
                      {labels?.refundHistory_filterButton}
                    </Row>
                  </AppButton>
                </Column>
                {/** To remove display: 'none' when this feature is available */}
                <Column className="reimbursement-history-declarationsbuttoncolumn">
                  <AppButton
                    className="reimbursement-history-declarationsbutton"
                    variant="secondary">
                    <Row className="reimbursement-history-declarationsrow">
                      <Icon
                        className="reimbursement-history-declarationsicon"
                        name={Icons.DECLARATIONS}
                        color={buStyles?.primaryColor || colors.blue}
                        width="16"
                        height="16"
                        changeViewbox={false}
                      />
                      {labels?.refundHistory_declarations}
                    </Row>
                  </AppButton>
                </Column>
              </Row>

              <ReimbursementsList
                reimbursementItems={
                  refunds && refunds?.data && refunds.data.length > 0
                    ? refunds.data
                    : []
                }
                statuses={statuses}
                changedItem={changedItem}
                ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
              />
            </Column>
          </Row>
        )}
      </Column>
      <div className="expense-detail-modal">
        <ReimbursementsDetail
          color={color}
          expenses={refundDetails}
          setShowModal={setShowModal}
          showModal={showModal}
          ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
          selectedItem={selectedItem}
          setUpdateFlag={setUpdateFlag}
          updateFlag={updateFlag}
          changedItem={changedItem}
          checkdate={selectedItem.checkDate || ''}
          statuses={statuses}
          loadingDetail={loadingDetail || loadingPaymentDetail}
          isLoading={isLoading}
          errorLoading={errorLoadingDetail}
          loadingPaymentDetail={loadingPaymentDetail}
          ibanDetails={ibanDetails}
        />
      </div>
      <ClaimsFilterModal
        setShowFilterModal={setShowFilterModal}
        showFilterModal={showFilterModal}
        filterProps={filter}
        setFilter={setFilter}
        modalWasClosed={modalWasClosed}
      />
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  strings,
  user,
  availableBus,
  globalStyles,
  iban,
  busFuncMap,
  titular,
  bankAccountDataHolder,
  userBankAccountDataWasUpdated,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  labels: strings.value.pt.refund,
  createRefundLabels: strings.value.pt.createRefund,
  stringsIban: strings.value.pt.ibanRefunds,
  availableBus: availableBus.value,
  buStyles: globalStyles.value,
  iban: iban.value,
  busFuncMap: busFuncMap.value,
  titular: titular.value,
  bankAccountDataHolder: bankAccountDataHolder.value,
  userBankAccountDataWasUpdated: userBankAccountDataWasUpdated.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIbanFilterOpenTrigger: (value: any) =>
    dispatch(setIbanFilterOpenTrigger(value)),
  setDisableReimbursementRequestButton: (value: any) =>
    dispatch(setDisableReimbursementRequestButton(value)),
  setIban: (value: any) => dispatch(setIban(value)),
  setTitular: (value: any) => dispatch(setTitular(value)),
  setUserBankAccountDataWasUpdated: (value: any) =>
    dispatch(setUserBankAccountDataWasUpdated(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ReimbursementHistory)
);
